var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DBox',{attrs:{"id":'cmp-distribution-statement-sidewindow-catalog',"addButton":false,"addLink":true,"addLinkLabel":'Upload Data',"rightMenu":[
    {
      text: _vm.$t('proceed_import'),
      value: 'proceed_import',
      class: _vm.isDisabled,
    } ]},on:{"menuClick":_vm.onMenuClick,"add_click":_vm.onAdd}},[_c('div',{staticClass:"ut-fh ut-fc",style:({
      overflowX: 'auto',
      width: (_vm.widthH + "px"),
    })},[(
        _vm.selectedStatementDetails &&
        _vm.selectedStatementDetails.file &&
        _vm.selectedStatementDetails.file.imported_data &&
        _vm.selectedStatementDetails.file.imported_data.length > 0
      )?_c('NTable',{staticClass:"h1",attrs:{"id":"contacts-contacts-contact_sidewindow-invoice_list","headers":_vm.headers,"items":_vm.list,"config":_vm.tableConfig},scopedSlots:_vm._u([{key:"thead",fn:function(ref){
      var thcon = ref.thcon;
return [_c('tr',_vm._l((_vm.headers),function(header){return _c('th',_vm._b({key:header.value},'th',thcon(header.value),false),[(!_vm.isDSSEnabled)?_c('Dropdown2',{staticClass:"dbox1",attrs:{"showLabel":false,"disabled":false,"options":_vm.columnNameTV,"placeholder":_vm.$t(''),"deselect":"","bb":'0px',"selected":_vm.columnNameTV.find(
                  function (e) { return e.value == _vm.finalColumnNames[header.value]; }
                )},on:{"selectedChange":function (e) { return _vm.onDropdownChange(header, e); }}}):_vm._e()],1)}),0)]}},{key:"item",fn:function(ref){
                var item = ref.item;
                var tdcon = ref.tdcon;
                var index = ref.index;
return [_c('tr',_vm._l((item),function(x,ci){return _c('td',_vm._b({key:(index + "_" + ci + "_" + x)},'td',tdcon(ci),false),[_c('span',[_vm._v(_vm._s(x))])])}),0)]}}],null,false,4239441609)}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }